import { createPortal } from "react-dom";
import { Phone, PhoneOff, Video as VideoIcon } from "lucide-react";
import { Avatar } from "@/components/common/Avatar";

// Incoming-call ringing sheet — shown to the callee while status === "ringing".
export function IncomingCall({ call, onAccept, onDecline }) {
  const caller = call?.caller;
  const isVideo = !!call?.video;
  return createPortal(
    <div className="fixed inset-x-0 top-0 z-[95] flex justify-center p-4" data-testid="incoming-call">
      <div className="w-full max-w-sm animate-fade-up rounded-3xl border border-white/12 bg-bloq-s1/95 p-5 shadow-2xl backdrop-blur-xl">
        <div className="flex items-center gap-3">
          <span className="relative">
            <span className="absolute inset-0 animate-ping rounded-full bg-bloq-mint/30" />
            <Avatar user={caller} size="md" />
          </span>
          <div className="min-w-0 flex-1">
            <div className="truncate text-base font-bold text-white" data-testid="incoming-caller-name">{caller?.display_name || "Someone"}</div>
            <div className="flex items-center gap-1.5 text-xs text-bloq-mint">
              {isVideo ? <VideoIcon className="h-3.5 w-3.5" /> : <Phone className="h-3.5 w-3.5" />}
              Incoming {isVideo ? "video" : "voice"} call…
            </div>
          </div>
        </div>
        <div className="mt-4 flex gap-3">
          <button
            onClick={onDecline}
            className="flex flex-1 items-center justify-center gap-2 rounded-2xl bg-destructive/90 py-3 text-sm font-bold text-white transition-colors hover:bg-destructive"
            data-testid="incoming-decline-btn"
          >
            <PhoneOff className="h-4 w-4" /> Decline
          </button>
          <button
            onClick={onAccept}
            className="flex flex-1 items-center justify-center gap-2 rounded-2xl bg-bloq-mint py-3 text-sm font-bold text-bloq-bg transition-opacity hover:opacity-90"
            data-testid="incoming-accept-btn"
          >
            <Phone className="h-4 w-4" /> Accept
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
